module.exports = __webpack_public_path__ + "img/logo.88508d28.png";